import { getPositionFromDate } from "../../utils/ActionPlan.utils";
import { Typography } from "../ui/Typography/Typography";
import "./ActionPlanTimeline.scss";

interface ActionPlanNowIndicatorProps {
  now: Date;
  startDate: Date;
  endDate: Date;
  label: string;
}

export const ActionPlanNowIndicator = ({
  now,
  startDate,
  endDate,
  label,
}: ActionPlanNowIndicatorProps) => {
  if (now < startDate || now > endDate) return null;

  const position = getPositionFromDate(now, startDate, endDate);

  return (
    <div className="ActionPlanNowIndicator">
      <div
        className="ActionPlanNowIndicator__line"
        style={{ left: `${position}%` }}
      >
        <Typography
          desktop="button2"
          color="secondary"
          weight="bold"
          className="ActionPlanNowIndicator__line__label"
        >
          {label}
        </Typography>
      </div>
    </div>
  );
};
